import React, { useEffect, useState } from "react";
import { useSession } from "../session/Context";
import api from "../Api";
import { toast } from "react-toastify";
import { Navigate, useNavigate } from "react-router-dom";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import OutlinedInput from '@mui/material/OutlinedInput';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
PaperProps: {
    style: {
    maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
    width: 250,
    },
},
};

export default function CreateGhost(props:any) {
    const navigate = useNavigate();
    const [templates, setTemplates] = useState<any[]>([]);
    const [selectedTemplate, setSelectedTemplate] = useState<string[]>([]);
    const [brandData, setBrandData] = useState({
        id: "",
        name: "",
        is_ghost: true,
        types:[],
    });

    const [issuance, setIssuance] = useState<any>({
        id: "",
        scope: false,
        details: false,
    });

    useEffect(()=>{
        if(props.sessionStatus === "ERROR"){
            console.log("session is in error");
        }
    },[])

    useEffect(()=>{
        changeBrandData("types", selectedTemplate);
       
    },[selectedTemplate])

    useEffect(() => {
        api("/api/v1/schemas?type=list-schema-factories")
          .then(async (response) => {
            setTemplates(
              Object.keys(response).map((val) => {
                return {
                  value: val,
                  label: response[val],
                };
              })
            );
           
          })
          .catch((err) => {
            console.error(err);
          });
    }, []);

  const changeBrandData = (name: string, data: any): void => {
    setBrandData({ ...brandData, [name]: data });
  };

  const onNewBrand = (event: React.FormEvent<HTMLFormElement>): void => {
    event.preventDefault();
    api("/api/v1/brand", {
      method: "POST",
      body: JSON.stringify(brandData),
    })
    .then((response) => {
        toast.success("Registered a ghost company "+brandData.name, { theme: "colored" });
        resetValues();

    })
    .catch((reason) => {
        toast.error("Error " + reason, { theme: "colored" });
    });
  };

  const handleChangeTemplate = (event: SelectChangeEvent<string[]>) => {
    setSelectedTemplate(typeof event.target.value === 'string' ? event.target.value.split(','): event.target.value);
    setIssuance({
      ...issuance,
      id: templates.find((val) => event.target.value === val.value),
    });
  };

  const resetValues = () => {
    setSelectedTemplate([]);
    setBrandData({id: "",
        name: "",
        is_ghost: true,
        types:[],
    })
    setIssuance({
        id: "",
        scope: false,
        details: false,
    })

  }

  return (<>
    
    <main>
        <div className="mobile-pro">
            <h1>Create ghost brand</h1>
        </div>

        <div className="col-content">
            <div className="notifications-container">
                <div className="credentials-container">   
                    <div className="signin-container">  
                        <h2>Register a ghost company</h2>
                        <br></br>

                        <form className="form" onSubmit={onNewBrand}>
                            <div>
                                <label>
                                    <span className="requiredMark">*</span> Company name{" "}
                                </label>
                                <input
                                    type="text"
                                    className="template-field"
                                    name="name"
                                    maxLength={140}
                                    placeholder="Name of the company"
                                    value={brandData.name}
                                    onChange={(event) => {
                                        changeBrandData("name", event.target.value);
                                    }}
                                    required
                                ></input>


                                <label>Template:</label>
                                <Select<string[]>
                                labelId="demo-multiple-name-label"
                                id="demo-multiple-name"
                                className="template-field"
                                multiple
                                value={selectedTemplate}
                                onChange={handleChangeTemplate}

                                input={<OutlinedInput />}
                                MenuProps={MenuProps}
                                >
                                {templates.map((name) => (
                                    <MenuItem
                                        key={name.value}
                                        value={name.value}
                                    >
                                    {name.label}
                                    </MenuItem>
                                ))}
                                </Select>
                                
                            </div>

                            <button  className="btn btn-primary onboarding" type="submit">
                                Register
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </main>
  </>);
}
